import apiClient, { ApiResponse } from '../api/client';
import { County, CountyContact } from '../types/models';

export interface UpdateCountyData {
  name?: string;
  code?: string;
  description?: string;
  address?: string;
  website?: string;
  logo?: File;
}

export interface CreateCountyContactData {
  contact_type: 'phone' | 'email' | 'address' | 'social';
  value: string;
  label?: string;
  is_primary?: boolean;
  is_public?: boolean;
}

class ProfileService {
  private baseUrl = '/admin/county/profile';

  async getProfile(): Promise<ApiResponse<County>> {
    return apiClient.get<County>(this.baseUrl);
  }

  async updateProfile(data: UpdateCountyData): Promise<ApiResponse<County>> {
    if (data.logo) {
      const formData = new FormData();
      Object.entries(data).forEach(([key, value]) => {
        if (value !== undefined) {
          formData.append(key, value);
        }
      });
      return apiClient.post<County>(`${this.baseUrl}/update`, formData, {
        headers: { 'Content-Type': 'multipart/form-data' }
      });
    }
    return apiClient.put<County>(this.baseUrl, data);
  }

  async uploadLogo(file: File): Promise<ApiResponse<County>> {
    const formData = new FormData();
    formData.append('logo', file);
    return apiClient.post<County>(`${this.baseUrl}/logo`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' }
    });
  }

  async deleteLogo(): Promise<ApiResponse<County>> {
    return apiClient.delete(`${this.baseUrl}/logo`);
  }

  // County Contacts
  async getContacts(): Promise<ApiResponse<CountyContact[]>> {
    return apiClient.get<CountyContact[]>(`${this.baseUrl}/contacts`);
  }

  async createContact(data: CreateCountyContactData): Promise<ApiResponse<CountyContact>> {
    return apiClient.post<CountyContact>(`${this.baseUrl}/contacts`, data);
  }

  async updateContact(id: number, data: Partial<CreateCountyContactData>): Promise<ApiResponse<CountyContact>> {
    return apiClient.put<CountyContact>(`${this.baseUrl}/contacts/${id}`, data);
  }

  async deleteContact(id: number): Promise<ApiResponse> {
    return apiClient.delete(`${this.baseUrl}/contacts/${id}`);
  }

  async setPrimaryContact(id: number): Promise<ApiResponse<CountyContact>> {
    return apiClient.post<CountyContact>(`${this.baseUrl}/contacts/${id}/set-primary`);
  }
}

export const profileService = new ProfileService();
export default profileService;
